/**
 *
 * RecoverPasswordSuccess
 *
 */

import React from "react"

import { FormattedMessage } from "react-intl"
import img from "images/brand/Mandu_white.svg"
import "./index.less"
import { Link } from "react-router-dom"
import messages from "./messages"
import { loadTextsLocalStorage } from "../../utils/i18n"

class ForgottenPasswordSuccess extends React.Component {
  intl = loadTextsLocalStorage("login")
  render() {
    return (
      <div className="loginContainer">
        <div className="recoverContainer">
          <Link to="login" onClick={this.props.onReset}>
            <img src={img} alt="" />
          </Link>
          <span>
            <strong>{this.intl.sendedEmailForgotPasswordForm.title}</strong>
          </span>
          <div className="spanContainer">
            <span>
            {this.intl.sendedEmailForgotPasswordForm.description_one}
            </span>
            <span>
            {this.intl.sendedEmailForgotPasswordForm.description_two}
            </span>
          </div>
          <span>
          {this.intl.sendedEmailForgotPasswordForm.message}
            {"\u00A0"} {this.intl.sendedEmailForgotPasswordForm.enter_again}
            {"\u00A0"}
            <strong
              id="reset"
              style={{ color: "white", textDecoration: "underline" }}
              onClick={() => {
                this.props.onReset()
              }}>
              {this.intl.sendedEmailForgotPasswordForm.action}
            </strong>
          </span>
        </div>
      </div>
    )
  }
}

ForgottenPasswordSuccess.propTypes = {}

export default ForgottenPasswordSuccess
